export default __webpack_public_path__ + "static/media/dots_right.7c3e6ef5.svg";